// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"df8f6937","787":"15230f2c"}[chunkId] + ".chunk.js";
};